


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Role } from "@/types/api/admin";
import { allRole, adminRoleById } from "@/api/admin";
import copy from "@/utils/deepCopy";
import print from "@/utils/print";

@Component
export default class Header extends Vue {
  @Prop() private form!: any;
  @Prop([String]) private dialogTitle!: string;
  @Prop([Boolean]) private dialogVisible!: boolean;
  // 初始数据可以直接声明为实例的 property
  roleList: Array<Role> = [];
  formData: any = {};

  mounted() {
    this.getAllRole();
  }

  @Watch("form")
  setForm(val: any) {
    this.formData = {
      ...val,
      ids: [],
    };
    adminRoleById({ adminId: this.form.id }).then((res) => {
      this.formData.ids = (res.data && res.data.map((e: any) => e.id)) || [];
    });
  }

  // 获取所有角色
  getAllRole() {
    allRole().then((res: any) => {
      this.roleList = res.data;
    });
  }
  // 关闭之前
  beforeClose() {
    this.$emit("close");
  }
}
